import { render, staticRenderFns } from "./TransferIntoHKIndex.vue?vue&type=template&id=1fe7cfd8&scoped=true&"
import script from "./TransferIntoHKIndex.vue?vue&type=script&lang=ts&"
export * from "./TransferIntoHKIndex.vue?vue&type=script&lang=ts&"
import style0 from "./TransferIntoHKIndex.vue?vue&type=style&index=0&id=1fe7cfd8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe7cfd8",
  null
  
)

export default component.exports